import * as R from 'ramda'

import {
  EDITOR_ACCENT_COLOR,
  EDITOR_BACKGROUND_COLOR,
  EDITOR_DIVIDER_FILL_MODE,
  EDITOR_NAV_WIDTH_PRO_MODE,
  EDITOR_COMMENTS_SHOW,
  EDITOR_TASKS_SHOW,
  EDITOR_ASK_V2,
  EDITOR_GRID_COLOR,
  EDITOR_FLEX_COLOR,
  EDITOR_ABSOLUTE_COLOR,
  EDITOR_SHOW_GRID,
} from 'constants/localStorageKeys'

import { DEFAULT_SETTINGS } from './constants'
import type { IEditorSettings } from './types'

const getLsItem = (key: string) => {
  const item = localStorage.getItem(key)
  try {
    return JSON.parse(item || '')
  } catch (error) {
    return item
  }
}

export const getEditorSettings = () => {
  const backgroundColor = getLsItem(EDITOR_BACKGROUND_COLOR)
  const accentColor = getLsItem(EDITOR_ACCENT_COLOR)
  const divider = getLsItem(EDITOR_DIVIDER_FILL_MODE)
  const navWidth = R.clamp(
    DEFAULT_SETTINGS.navWidth,
    500,
    Number(getLsItem(EDITOR_NAV_WIDTH_PRO_MODE)) || 0,
  )
  const comments = getLsItem(EDITOR_COMMENTS_SHOW)
  const tasks = getLsItem(EDITOR_TASKS_SHOW)
  const askV2 = getLsItem(EDITOR_ASK_V2)
  const gridColor = getLsItem(EDITOR_GRID_COLOR)
  const flexColor = getLsItem(EDITOR_FLEX_COLOR)
  const absoluteColor = getLsItem(EDITOR_ABSOLUTE_COLOR)
  const showGrid = getLsItem(EDITOR_SHOW_GRID)

  return R.mergeRight(
    DEFAULT_SETTINGS,
    R.filter((i) => !R.isNil(i), {
      backgroundColor,
      accentColor,
      divider,
      navWidth,
      comments,
      tasks,
      askV2,
      gridColor,
      flexColor,
      absoluteColor,
      showGrid,
    }),
  ) as IEditorSettings
}

export const setEditorSettings = (settings: IEditorSettings) => {
  const { askV2, absoluteColor, flexColor, gridColor, showGrid } = settings
  const { backgroundColor, accentColor, divider, navWidth, comments, tasks } = settings

  localStorage.setItem(EDITOR_BACKGROUND_COLOR, JSON.stringify(backgroundColor))
  localStorage.setItem(EDITOR_ACCENT_COLOR, JSON.stringify(accentColor))
  localStorage.setItem(EDITOR_DIVIDER_FILL_MODE, JSON.stringify(divider))
  localStorage.setItem(EDITOR_NAV_WIDTH_PRO_MODE, JSON.stringify(navWidth))
  localStorage.setItem(EDITOR_COMMENTS_SHOW, JSON.stringify(comments))
  localStorage.setItem(EDITOR_TASKS_SHOW, JSON.stringify(tasks))
  localStorage.setItem(EDITOR_ASK_V2, JSON.stringify(askV2))
  localStorage.setItem(EDITOR_GRID_COLOR, JSON.stringify(gridColor))
  localStorage.setItem(EDITOR_FLEX_COLOR, JSON.stringify(flexColor))
  localStorage.setItem(EDITOR_ABSOLUTE_COLOR, JSON.stringify(absoluteColor))
  localStorage.setItem(EDITOR_SHOW_GRID, JSON.stringify(showGrid))
}
